/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkMergeSourcesRequest
 */
export interface BulkMergeSourcesRequest {
    /**
     * The ID of the source that survives the merge
     */
    source_to_keep_id: string;
    /**
     * The IDs of the sources being merged away
     */
    source_to_merge_ids: Array<string>;
}

/**
 * Check if a given object implements the BulkMergeSourcesRequest interface.
 */
export function instanceOfBulkMergeSourcesRequest(value: object): value is BulkMergeSourcesRequest {
    if (!('source_to_keep_id' in value) || value['source_to_keep_id'] === undefined) return false;
    if (!('source_to_merge_ids' in value) || value['source_to_merge_ids'] === undefined) return false;
    return true;
}

export function BulkMergeSourcesRequestFromJSON(json: any): BulkMergeSourcesRequest {
    return BulkMergeSourcesRequestFromJSONTyped(json, false);
}

export function BulkMergeSourcesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkMergeSourcesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'source_to_keep_id': json['source_to_keep_id'],
        'source_to_merge_ids': json['source_to_merge_ids'],
    };
}

export function BulkMergeSourcesRequestToJSON(json: any): BulkMergeSourcesRequest {
    return BulkMergeSourcesRequestToJSONTyped(json, false);
}

export function BulkMergeSourcesRequestToJSONTyped(value?: BulkMergeSourcesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_to_keep_id': value['source_to_keep_id'],
        'source_to_merge_ids': value['source_to_merge_ids'],
    };
}

